import { forwardRef } from "react";
import { Text as NativeText } from "./Text";
import { jsx } from "react/jsx-runtime";
const Text = forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsx(NativeText, { ref, ...props });
});
export {
  Text
};
